import smali from "refractor/smali";
export default smali;